import { render } from "./BaseSvgIcon.vue?vue&type=template&id=f36065b8"
import script from "./BaseSvgIcon.vue?vue&type=script&lang=js"
export * from "./BaseSvgIcon.vue?vue&type=script&lang=js"

import "./BaseSvgIcon.vue?vue&type=style&index=0&id=f36065b8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__